define([], function() {
    'use strict';

    var has = function(obj, key) {
        return obj != null && hasOwnProperty.call(obj, key);
    };

    return has;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/has.js
 ** module id = 25
 ** module chunks = 0
 **/